import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

export default function MapView({ items = [], onSelect }) {
  const ref = useRef(null);
  const mapRef = useRef(null);
  const layerRef = useRef(null);

  useEffect(() => {
    if (!ref.current) return;
    const pts = items.filter((b) => b.lat && b.lng);
    if (!mapRef.current) {
      mapRef.current = L.map(ref.current).setView(pts[0] ? [pts[0].lat, pts[0].lng] : [45.67, 11.93], 10);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "© OpenStreetMap", maxZoom: 19,
      }).addTo(mapRef.current);
    }
    if (layerRef.current) layerRef.current.remove();
    layerRef.current = L.layerGroup().addTo(mapRef.current);
    pts.forEach((b) => {
      const m = L.marker([b.lat, b.lng]).addTo(layerRef.current);
      m.bindPopup(`<b>${b.trade_name}</b><br>${b.city || ""}${b.avg_rating ? "<br>★ " + b.avg_rating : ""}`);
      m.on("click", () => onSelect && onSelect(b));
    });
    if (pts.length) {
      try {
        const g = L.featureGroup(pts.map((b) => L.marker([b.lat, b.lng])));
        mapRef.current.fitBounds(g.getBounds().pad(0.2));
      } catch (e) { /* ignore fit-bounds errors */ }
    }
    const map = mapRef.current;
    const t = setTimeout(() => { try { if (map && map._container) map.invalidateSize(); } catch (e) { /* ignore */ } }, 200);
    return () => clearTimeout(t);
  }, [items, onSelect]);

  useEffect(() => () => {
    try { if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; } } catch (e) { /* ignore */ }
  }, []);

  return <div ref={ref} data-testid="map-view" style={{ height: "62vh" }} className="rounded-[18px] overflow-hidden border border-[#DADFEA] z-0" />;
}
